const ADDRESS_MASK = 0x7ffffff;

export const getPadVadHumanReadable = (external_id: number) => {
  // eslint-disable-next-line no-bitwise
  return external_id & ADDRESS_MASK;
};
